import { ContactForm } from "./ContactForm";
import { MembershipForm } from "./MembershipForm";

export const ContactSection = () => (
  <section
    id="contact"
    data-testid="contact-section"
    className="py-24 bg-neutral-900 border-b border-neutral-800"
  >
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="mb-12">
        <h2 className="font-display text-3xl sm:text-4xl font-black uppercase text-white">
          Contatti & Tesseramento
        </h2>
        <p className="text-sm text-neutral-400 mt-1">
          Invia una richiesta alla segreteria oppure tesserati online al Club Legend Team.
        </p>
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-stretch">
        <ContactForm />
        <MembershipForm />
      </div>
    </div>
  </section>
);
